export const MeasureTypes = Object.freeze({
  ASSESSMENT: 'assessment',
  SYMPTOM: 'symptom',
  WORKSHEET: 'worksheet'
})
